export enum NotifierPosition {
  TopCenter,
  TopLeft,
  TopRight,
  BottomCenter,
  BottomLeft,
  BottomRight,
}
